import projects from './projects';
import admin from './admin';
import dashboard from './dashboard';
import projectsManagement from './projectManagement';
import defaultValidating from './defaultValidating';
import providers from './providers';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = (user) => {
  const role = JSON.parse(user?.reloadUserInfo?.customAttributes).role;
  let items = [];

  if (!JSON.parse(user?.reloadUserInfo?.customAttributes).isFormatOK) {
    items = [defaultValidating];
  } else if (role === 'ADMIN_ROLE') {
    items = [projectsManagement, dashboard, providers, admin];
  } else if (role === 'PM_ROLE') {
    items = [projectsManagement, projects, dashboard, providers];
  } else {
    items = [projects, dashboard, providers];
  }
  return items;
};

export default menuItems;
